import * as React from "react";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {api} from "../../../api/api";
import "./partnerMigration.scss";
import PartnerRewardPointsMigrationDetails from "../../../model/partnerMigration/PartnerRewardPointsMigrationDetails";
import {none, option, Option} from "ts-option";
import Toast from "../../helper/Toast";
import Spinner from "../../../hiberUiKit/src/atoms/Spinner/Spinner";

const spinner = require("./../../../../resources/hiber/img/spinner-orange.png");

enum MigrationStatus {
	BEFORE_START,
	IN_PROGRESS,
	ERROR,
	SUCCESS_WITH_FAILURES,
	SUCCESS,
}

interface ComponentProps {
	proceedToApp: () => void;
}

interface State {
	migrationStatus: MigrationStatus,
	migrationDetails: Option<PartnerRewardPointsMigrationDetails>,
}

export default class MigrationView extends React.PureComponent<ComponentProps, State> {
	migrationLabel: string = "Partner reward points migration to Xero";
	proceedToAppButton = <ButtonPrimary label={"Proceed to portal"}
										onClick={this.props.proceedToApp}/>;

	constructor(props: ComponentProps) {
		super(props);
		this.state = {
			migrationStatus: MigrationStatus.BEFORE_START,
			migrationDetails: none
		};
	}

	render() {
		return (
			<div className="c-partner-migration_migration-container">
				<h3 className="c-partner-migration_header">{this.migrationLabel}</h3>
				{this.state.migrationStatus === MigrationStatus.BEFORE_START &&
				<div className="c-partner-migration_start-button-container">
					<ButtonPrimary label={"Start migration"}
								   onClick={this.onMigrationStart}/>
				</div>}
				<div className="c-partner-migration_statistics-container">
					{this.state.migrationDetails.map(this.renderStatistics).orNull}
				</div>
				<div className="c-partner-migration_status-container">
					{this.renderStatus()}
				</div>
			</div>
		);
	}

	renderStatistics = (migrationDetails: PartnerRewardPointsMigrationDetails) => {
		const label = "partners";
		return (
			<table className="c-partner-migration_table">
				<tr>
					<td>Total {label}:</td>
					<td>{migrationDetails.totalPartners}</td>
				</tr>
				<tr>
					<td>Completed {label}:</td>
					<td>{migrationDetails.completedPartners}</td>
				</tr>
				<tr>
					<td>Failed {label}:</td>
					<td>{migrationDetails.failedPartners}</td>
				</tr>
			</table>
		);
	};

	renderStatus = () => {
		switch (this.state.migrationStatus) {
			case MigrationStatus.IN_PROGRESS:
				return (
					<Spinner imgUrl={spinner} size={72}/>
				);
			case MigrationStatus.ERROR:
				return (
					<>
						<span className="c-partner-migration_failure">{`${this.migrationLabel} failed.`}</span>
						{this.startOverButton(this.onMigrationStart)}
					</>
				);
			case MigrationStatus.SUCCESS_WITH_FAILURES:
				return (
					<>
						<span className="c-partner-migration_success-with-errors">
							{`${this.migrationLabel} finished with errors.`}
							</span>
						<div>
							{this.proceedToAppButton}
							{this.startOverButton(this.onMigrationStart)}
						</div>
					</>
				);
			case MigrationStatus.SUCCESS:
				return (
					<>
						<span className="c-partner-migration_success">{`${this.migrationLabel} complete.`}</span>
						{this.proceedToAppButton}
					</>
				);
		}
	};

	onMigrationStart = () => {
		this.setState({migrationStatus: MigrationStatus.IN_PROGRESS, migrationDetails: none},
			() => api.instance.migrationApi.runPartnerRewardPointsMigration()
				.then(() => {
					Toast.success(`${this.migrationLabel} started`);
					setTimeout(this.checkMigrationStatus, 1000);
				})
				.catch(err => {
					console.log(err);
					this.setState({migrationStatus: MigrationStatus.ERROR});
					notifyBugsnagAndShowToast(err, `${this.migrationLabel} failed`);
				})
		);
	};

	startOverButton = (onClick: () => void) => {
		return (
			<div className="c-partner-migration_start-over-button">
				<ButtonPrimary label={"Start over"} onClick={onClick}/>
			</div>
		)
	};

	checkMigrationStatus = () => {
		api.instance.migrationApi.fetchMigrationStatusDetails()
			.then(migrationDetails => {
				this.setState({migrationDetails: option(migrationDetails)});
				if (migrationDetails.running) {
					setTimeout(this.checkMigrationStatus, 5000);
				}
				else if (migrationDetails.status === "COMPLETED") {
					if (migrationDetails.failedPartners > 0
						|| migrationDetails.completedPartners !== migrationDetails.totalPartners) {
						this.setState({migrationStatus: MigrationStatus.SUCCESS_WITH_FAILURES});
						Toast.warning(`${this.migrationLabel} finished with errors`);
					}
					else {
						this.setState({migrationStatus: MigrationStatus.SUCCESS});
						Toast.success(`${this.migrationLabel} finished successfully`);
					}
				}
				else if (migrationDetails.status === "FAILED") {
					this.setState({migrationStatus: MigrationStatus.ERROR});
				}
			})
			.catch(err => {
				this.setState({migrationStatus: MigrationStatus.ERROR});
				notifyBugsnagAndShowToast(err, `${this.migrationLabel} status check failed`);
			});
	};
}
